import React, { useCallback } from "react";
import { ChakraProps, useToast } from "@chakra-ui/react";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import AsyncSelect from "./AsyncSelect";
import { Vendor } from "@worldwidewebb/client-assets";
import { getVendors } from "../../api/vendors/useVendors";

interface SelectVendorProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectVendor: React.FC<SelectVendorProps> = ({ color, value, setValue, ...chakraProps }) => {
  const toast = useToast();

  const handleSearch = useCallback(
    async (searchQuery?: string): Promise<[string, string][]> => {
      let vendors: Vendor[] = [];

      try {
        vendors = await getVendors(searchQuery);
      } catch (error) {
        toast({
          title: "API error occurred",
          description: (error as Error).message,
          status: "error",
        });
      }

      return vendors.map(({ vendorId }) => [vendorId, vendorId]);
    },
    [toast]
  );

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect selectedValue={value} setSelectedValue={setValue} color={color} title={"Vendor"} {...chakraProps} />
    </AsyncSearchProvider>
  );
};

export default SelectVendor;
